import { RootState } from 'typesafe-actions';

export const filterSelector = (state: RootState) => state.assignDevice.filter;

export const assignDeviceClientItemsSelector = (state: RootState) => state.assignDevice.items;

export const assignDeviceLoadingSelector = (state: RootState) => state.assignDevice.loading;

export const assignDeviceErrorSelector = (state: RootState) => state.assignDevice.error;
